module.exports = __webpack_public_path__ + "static/media/bolt_purple.71bd9fb0.svg";